import axios from 'axios';
import qs from 'qs'
 
// let base = 'http://52.15.37.68:8103/api';
// let base = 'https://app.geri-safe.com/api'
let base="/api"
export const server = axios.create({
    timeout:10000
})

export const requestLogin = params => {
    return server.post(`${base}/publicusers/Login`, qs.stringify(params)).then(res => res.data);
};

export const phoneCodeLogin = params => {
    return server.post(`${base}/publicusers/Captchalogin`, qs.stringify(params)).then(res => res.data);//手机验证码登录
};

export const druglistList = params => {
    return server.post(`${base}/watch/GetUserMedicineCupList`, qs.stringify(params)).then(res => res.data);//获取用户药杯列表
};

export const GetInvalidInformationOperation = params => {
    return server.post(`${base}/watch/GetInvalidInformationOperation`, qs.stringify(params)).then(res => res.data);//用户信息操作列表，过敏史/病例/爱好
};

export const InvalidContactsList = params => {
    return server.post(`${base}/watch/InvalidContactsList`, qs.stringify(params)).then(res => res.data);//查询患者联系人列表
};

export const getPatientInfo = params => {
    return server.post(`${base}/patientuser/GetPatientInfo`, qs.stringify(params)).then(res => res.data);//获取病人信息
};

export const GetMedicinetakelog = params => {
    return server.post(`${base}/watch/GetMedicinetakelog`, qs.stringify(params)).then(res => res.data);//药物历史记录
};

export const GetNoticeList = params => {
    return server.post(`${base}/watch/GetNoticeList`, qs.stringify(params)).then(res => res.data);//获取通知告警列表
};

export const GetInvalidPharmacy = params => {
    return server.post(`${base}/watch/GetInvalidPharmacy`, qs.stringify(params)).then(res => res.data);//获取通知告警列表
};

export const InvalidList = params => {
    return server.post(`${base}/watch/InvalidList`, qs.stringify(params)).then(res => res.data);//查询患者列表
};

export const ChangePassword = params => {
    return server.post(`${base}/publicusers/ChangePassword`, qs.stringify(params)).then(res => res.data);//修改密码
};

export const SetRelatives = params => {
    return server.post(`${base}/watch/SetRelatives`, qs.stringify(params)).then(res => res.data);//设置展示用户
};

export const sendCode = params => {
    return server.post(`${base}/sms/Send`, qs.stringify(params)).then(res => res.data);//获取手机短信
};

export const Resetpwd = params => {
    return server.post(`${base}/publicusers/Resetpwd`, qs.stringify(params)).then(res => res.data);//忘记密码修改
};

export const GetUserInfo = params => {
    return server.post(`${base}/ordinaryuser/GetUserInfo`, qs.stringify(params)).then(res => res.data);//获取用户信息
};

export const getDrugtakemedicine = params => {
    return server.post(`${base}/reportforms/getdrugtakemedicine`, qs.stringify(params)).then(res => res.data);//获取药品服药报表
}

export const getMonthDrugtakemedicine = params => {
    return server.post(`${base}/reportforms/getmonthtakemedicine`, qs.stringify(params)).then(res => res.data);//获取药品服药报表汇总
}

export const getMedicinePlanweeklog = params => {
    return server.post(`${base}/reportforms/getmedicine_planweeklog`, qs.stringify(params)).then(res => res.data);//获取药品服药时刻取药情况
}

export const getMotion = params => {
    return server.post(`${base}/patientuser/GetUserInformationOperation`, qs.stringify(params)).then(res => res.data);//运动爱好接口
};




// WEBPACK FOOTER //
// ./src/api/api.js